export const googleLogin = (returnPath = "/dashboard") => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + returnPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const GoogleIcon = () => (
  <svg className="h-5 w-5" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.8 6C12.3 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.4 5.7c4.3-4 7.2-9.9 7.2-17.4z"/><path fill="#FBBC05" d="M10.4 28.7A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.8-6z"/><path fill="#34A853" d="M24 48c6.2 0 11.6-2 15.4-5.6l-7.4-5.7c-2 1.4-4.7 2.3-8 2.3-6.3 0-11.7-4.1-13.6-9.8l-7.8 6C6.5 42.6 14.6 48 24 48z"/></svg>
);

export const GoogleButton = ({ label = "Login dengan Google", testId = "google-login-btn", returnPath }) => (
  <button type="button" onClick={() => googleLogin(returnPath)} data-testid={testId}
    className="w-full flex items-center justify-center gap-3 bg-white text-zinc-900 hover:bg-zinc-200 font-semibold rounded-md py-3 transition-colors">
    <GoogleIcon />{label}
  </button>
);

export const PinInput = ({ value, onChange, testId, placeholder = "PIN / password", autoFocus }) => (
  <input data-testid={testId} type="password" maxLength={32} autoComplete="current-password" autoFocus={autoFocus}
    value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value.replace(/\s/g, ""))}
    className="w-full bg-zinc-950 border border-zinc-800 focus:border-red-600 outline-none rounded-md px-3 py-2.5 font-mono tracking-widest text-lg text-center" />
);
